<template>
  <div class="navbar">
    <!--<breadcrumb class="breadcrumb-container"></breadcrumb>-->
    <div class="breadcrumb-container" style="color: white"><img style="height: 50px" :src="logo" alt="logo"></div>
    <div class="right-menu">
      <el-dropdown class="right-menu-item" trigger="click">
        <span>
          <i class="el-icon-s-flag"></i>
          
          <i class="el-icon-arrow-down el-icon--right">{{ $t("stock.chooselanguage") }}</i>
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span style="display:block;" @click="changeLanguage('zh')">{{$t('stock.chinese')}}</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <span style="display:block;" @click="changeLanguage('en')">{{$t('stock.english')}}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
//import Company from "@/components/Company/Index.vue";
import Breadcrumb from "@/components/Breadcrumb/Index.vue";
//import WaterVideo from "@/components/Video/Index.vue";
import logo_vmb from '@/assets/STYBIELLA_W.png';
import logo_vitality from '@/assets/vitality_logo.jpg';
import bus from "../../bus/eventBus.js";
export default {
  components: {
    Breadcrumb
  },

  data(){
    return {
    }  
  },
  computed: {
    userName() {
      return localStorage.realName;
    },
    logo(){
      if (process.env.VUE_APP_TYPE == "vmb"){
        return logo_vmb;
      }else if(process.env.VUE_APP_TYPE == "vitality"){
        return logo_vitality;
      }else{
        return logo_vmb;
      }
    }
  },

  methods: {
    logout() {
      localStorage.clear();
      this.$store.dispatch("tagsView/delAllViews", this.$route);
      this.$router.push({ path: "/login" });
    },
    changeLanguage(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("lang", locale);
    }
  }
};
</script>

<style lang="scss" >
.navbar {
  height: 50px;

  overflow: hidden;
  position: relative;
  background-color: #1f2b35;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .breadcrumb-container {
    float: left;
    margin-left: 26px;
    line-height: 50px;
  }

  .right-menu {
    float: right;
    line-height: 50px;
    height: 100%;

    .right-menu-item {
      cursor: pointer;
      float: left;
      margin-right: 26px;
      height: 100%;
      font-size: 12px;
      color: #fff;
    }
  }
}
</style>
